import { Inject, NgZone, AfterViewInit, OnDestroy, Component, Input } from '@angular/core';
import { Agency, Project } from '../../../models/index';
import { MapPlanBase } from './map-plan-base.model';
import { ListTrackingService } from './../../../utils/list-tracking.service';

@Component({
  selector: 'app-map-plan-project-base',
  templateUrl: './map-plan-project-base.component.html'
})
export class MapPlanProjectBaseComponent extends MapPlanBase implements AfterViewInit, OnDestroy {
  @Input() agency: Agency;
  @Input() projects: Project;

  constructor(
    public zone: NgZone,
    @Inject('WINDOW') public window: any,
    public listTrackingService: ListTrackingService
  ) {
    super(zone, window)
  }

  ngAfterViewInit(): void {
    this.runImgMappingScript();
  }

  ngOnDestroy(): void {
    this.removeImgMappingScript();
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/map-plan/map-plan-project-base.component.ts